'use strict';

/**
 * Type-guard - checks if a value is a key of a given object.
 *
 * @param x - The value to check.
 * @param props - The object to check against.
 * @returns A boolean indicating whether the value is a key of the object.
 */ function isKeyOf(x, props) {
    return typeof x === 'string' && x in props ? true : false;
}

module.exports = isKeyOf;
